(function () {
    'use strict';

    angular.module('app').factory('userService', userService);
    userService.$inject = ["$http", "$sessionStorage", "urlHelper", "handleException"];

        function userService($http, $sessionStorage, urlHelper, handleException){
        var dataService = $http;
        // var deferred = $q;
        return {
          
             getUser: function (vm) {
                return dataService.get("/jrwarea/api/JrwMembers/GetUser?email="+vm.PolicyHolder.Email)
                   .then(function (result) {
                       if (typeof result.data === 'object') {
                           var data = result.data;
                        
                           return data;
                       }

                   }, function (error) {
                       return error;
                       handleException.log(error);
                   });
               
             },

             updateUsername: function (email) {
                 return dataService.post("/jrwarea/api/JrwMembers/UpdateUsername?newEmail=" + email)
                    .then(function (result) {
                        if (typeof result.data === 'object') {
                            var data = result.data;

                            return data;
                        }

                    }, function (error) {
                        return error;
                        handleException.log(error);
                    });

             },
             sendMemberEmail: function (vm) {
                 return dataService.get("/jrwarea/api/JrwMembers/SendMemberEmail?name=" + vm.PolicyHolder.Forename + "&email=" + vm.PolicyHolder.Email)
                    .then(function (result) {
                        console.log(result);
                        console.log(result.data);
                        if (typeof result.data === 'object') {
                            var data = result;

                            return result.data;
                        }

                    }, function (error) {
                        console.log("sendMemberEmail has gone into error, error details:");
                        console.log(error);
                        handleException.log(error);
                    });

            },

            createOrUpdateMember: function (request) {
                return dataService.post(urlHelper.getSuperbrandApiUrl() + "memberswebapi/legacy", request)
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            },

            getMember: function (emailAddress) {
                return dataService.get("/api/JrwMembers/GetMember?email=" + emailAddress)
                   .then(function (result) {
                       return result.data;

                   }, function (error) {
                       handleException.log(error);
                   });

            },
            
            checkMemberEmailExists : function (vm) {
                return dataService.post("/jrwarea/api/JrwMembers/CheckMemberEmailExists?email=" + vm.PolicyHolder.Email)
                   .then(function (result) {
                       console.log("checkMemberEmailExists result: ");
                        console.log(result);
                       //if (typeof result.data === 'object') {
                       //    return result;
                       //    //var data = result;
                       //    //return result.data;
                       //}
                       return result;

                   }, function (error) {
                       console.log("checkMemberEmailExists gone into error");
                       console.log(error);
                       handleException.log(error);
                       return error;
                   });
             
            },
            getMemberByEmail: function (vm) {
                return dataService.get("/jrwarea/api/JrwMembers/GetMemberByEmail?email=" + vm.PolicyHolder.Email)
                   .then(function (result) {
                       if (typeof result.data === 'object') {
                           var data = result.data;

                           return data;
                       }

                   }, function (error) {
                       return error;
                       handleException.log(error);
                   });

            },
            GetLoggedInMember: function () {
                return dataService.get("/jrwarea/api/JrwMembers/GetLoggedInMember");
            },

            getOnlineUserLink: function () {
                return dataService.get("/jrwarea/api/JrwMembers/GetOnlineUserLink")
                   .then(function (result) {
                       return result;
                   }, function (error) {
                       handleException.log(error);
                   });
            },

            getSession: function (sessionId) {
                return dataService.get(urlHelper.getSuperbrandApiUrl() + "memberswebapi/legacy/sessions/" + sessionId)
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            },

            getPolicyHolderBySessionId: function (sessionId) {
                return dataService.get(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policyholder")
                   .then(function (result) {
                       return result;
                   }, function (error) {
                       handleException.log(error);
                   });
            },

            updatePolicyHolderBySessionId: function (sessionId, request) {
                return dataService.patch(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policyholder", request)
                   .then(function (result) {
                       return result;
                   }, function (error) {
                       handleException.log(error);
                   });
            },

            memberIsLoggedOn: function() {
                var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
                if (sessionId) {
                    return true;
                }
                return false;
            },

            setAutoRenewalOptOut: function (policyNumber, autoRenewalOptOut) {
                var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
                return dataService.patch(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber,
                    { autoRenewalOptOut: autoRenewalOptOut }                )
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                        throw error;
                    });
            },

            getPolicyByNumber: function (policyNumber) {
                return dataService.get("/api/policies/GetPolicyByNumber?policyNumber=" + policyNumber)
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            },

            getOnlineUserLinkByPolicyholderId: function (policyholderId) {
                return dataService.get("/jrwarea/api/JrwMembers/GetOnlineUserLink?policyholderId=" + policyholderId)
               .then(function (result) {
                   return result;
               }, function (error) {
                   handleException.log(error);
               });
            },

            resendAffordableGolfVoucher: function (sessionId, policyNumber) {
                return dataService.post(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber + "/vouchers/latest", { ResendAll: true })
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                        return Promise.reject(error);
                    });
            }
        }
    }
})();
